import * as R from 'ramda'

export const getIsFetchingProductList = R.path([
  'product',
  'processing',
  'getProductList'
])

export const getProductList = R.path(['product', 'productList'])

export const getIsFetchingProductDetail = R.path([
  'product',
  'processing',
  'getProductDetail'
])

export const getProductDetail = R.path(['product', 'productDetail'])

export const getIsCreateOrUpdatingProduct = R.path([
  'product',
  'processing',
  'createOrUpdatingProduct'
])
